// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "com.mewwallet",
    name: "MEW wallet",
    homepage: "https://mewwallet.com",
    image_id: "e2024511-2c9b-46d7-3111-52df3d241700",
    app: {
        browser: "https://download.mewwallet.com/?source=wc",
        ios: "https://apps.apple.com/app/id1464614025",
        android: "https://play.google.com/store/apps/details?id=com.myetherwallet.mewwallet",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: "https://apps.apple.com/app/id1464614025",
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "mewwallet://",
        universal: "https://mewwallet.com",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map